<template>
  <div
    v-if="
      !isPopupDisabled &&
      !isDisabledForSubscriber &&
      isToggleEnabled &&
      !isBlockerOpened
    "
    class="newsletter-toggle"
    :class="{ 'is-open': isOpened }"
  >
    <button
      type="button"
      class="button button--primary-alt"
      :class="{ disabled: !allowPopupActivation }"
      @click="onTogglePopup"
    >
      <span>{{ subscribeButtonLabel || 'Subscribe' }}</span>
      <i class="icon">
        <Icon name="fa6-regular:envelope" />
      </i>
    </button>
  </div>
</template>

<script setup lang="ts">
const { isPopupDisabled, isToggleEnabled } = useNewsletterContent()

const newsletterPopupStore = useNewsletterPopupStore()
const {
  isOpened,
  allowPopupActivation,
  isBlockerOpened,
  isDisabledForSubscriber,
} = storeToRefs(newsletterPopupStore)
const { openPopup, closePopup } = newsletterPopupStore

const { subscribeButtonLabel } = useNewsletterContent()

function onTogglePopup() {
  if (isOpened.value) {
    closePopup()
  } else {
    openPopup(true)
  }
}
</script>

<style lang="less" scoped>
.newsletter-toggle {
  position: fixed;
  top: 25%;
  right: 0;
  z-index: 999;
  display: flex;
  justify-content: end;
  transform: translate(0, -50%);

  @media @tablet {
    top: 34%;
  }

  @media @desktop {
    top: 50%;
  }

  button {
    transition:
      opacity 0.3s,
      transform 0.4s cubic-bezier(0.4, 0.6, 0.2, 1);
    gap: @3px;
    border-radius: unit(@border-radius-sm / 16, rem)
      unit(@border-radius-sm / 16, rem) 0 0;
    padding: 0 @gutter @2px;
    transform: rotate(-90deg) translate(50%, 0);
    transform-origin: right bottom;

    span {
      .font-sm();
      .font-bold();
    }

    &:focus {
      background-color: @color-primary;
      color: @color-text-reverse;
      border-color: @color-primary;

      > * {
        color: inherit;
      }
    }

    @media @tablet {
      padding: @7px @gutter-md @5px;
      gap: @6px;

      span {
        .font-base();
      }
    }

    &.disabled {
      transform: rotate(-90deg) translate(50%, 100%);
    }
  }

  &.is-open {
    button {
      opacity: 0.5;
      transform: rotate(-90deg) translate(50%, 12.5%);
    }
  }
}
</style>
